// extracted by mini-css-extract-plugin
export default {"activityInput":"StepTwo_activityInput__K264c","numberImg":"StepTwo_numberImg__LjtRH","stepNumber":"StepTwo_stepNumber__FUERn","titleActivity":"StepTwo_titleActivity__b6r5k"};